import { SVG, SVGProps } from './svg'

export function IconToolCallout(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path d="M11 13.5c0-.3.2-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5ZM11.5 16a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM6.5 11c0-2 1.6-3.5 3.5-3.5h12c2 0 3.5 1.6 3.5 3.5v7c0 2.5-2 4.5-4.5 4.5h-2.5c-.2 0-.3 0-.4.2l-1.7 2.1a.5.5 0 0 1-.8 0L14 22.7l-.4-.2H10c-2 0-3.5-1.6-3.5-3.5v-8ZM10 8.5A2.5 2.5 0 0 0 7.5 11v8c0 1.4 1.1 2.5 2.5 2.5h3.5c.5 0 1 .2 1.2.6l1.3 1.6 1.3-1.6c.3-.4.7-.6 1.2-.6H21c2 0 3.5-1.6 3.5-3.5v-7c0-1.4-1.1-2.5-2.5-2.5H10Z" />
    </SVG>
  )
}
